var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEmptyStateEvents = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 28,
    viewBox: "0 0 42 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 21V19H20H18C16.8954 19 16 18.1046 16 17V4C16 2.89543 16.8954 2 18 2H38C39.1046 2 40 2.89543 40 4V17C40 18.1046 39.1046 19 38 19H29H28.1716L27.5858 19.5858L22 25.1716V21ZM14 17C14 19.2091 15.7909 21 18 21H20V23V25.1716C20 26.9534 22.1543 27.8457 23.4142 26.5858L29 21H38C40.2091 21 42 19.2091 42 17V4C42 1.79086 40.2091 0 38 0H18C15.7909 0 14 1.79086 14 4V17ZM1 4C0.447715 4 0 4.44772 0 5C0 5.55228 0.447715 6 1 6H11C11.5523 6 12 5.55228 12 5C12 4.44772 11.5523 4 11 4H1ZM4 9C3.44772 9 3 9.44771 3 10C3 10.5523 3.44772 11 4 11H11C11.5523 11 12 10.5523 12 10C12 9.44771 11.5523 9 11 9H4ZM6 15C6 14.4477 6.44772 14 7 14H11C11.5523 14 12 14.4477 12 15C12 15.5523 11.5523 16 11 16H7C6.44772 16 6 15.5523 6 15ZM27 5.84775C27 5.29546 27.4477 4.84775 28 4.84775C28.5523 4.84775 29 5.29546 29 5.84775V11.1194C29 11.6717 28.5523 12.1194 28 12.1194C27.4477 12.1194 27 11.6717 27 11.1194V5.84775ZM28 15.7353C28.5523 15.7353 29 15.2876 29 14.7353C29 14.183 28.5523 13.7353 28 13.7353C27.4477 13.7353 27 14.183 27 14.7353C27 15.2876 27.4477 15.7353 28 15.7353Z",
    fill: "#071A24"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEmptyStateEvents);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/EmptyStateEvents.19c18b068304a28fa7116a075e3ced50.svg";